import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AppServiceService } from 'src/app/api/app-service.service';
import { ToppingsPage } from '../toppings/toppings.page';
import { TranslateService } from '@ngx-translate/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'welcome-package',
  templateUrl: './welcome-package-offer.page.html',
  styleUrls: ['./welcome-package-offer.page.scss'],
})
export class WelcomePackageOfferPage implements OnInit {

  @Input() package: any = null;

  public isheighok = true;
  public lanList: any = [];

  constructor(public modalController: ModalController, public appService: AppServiceService, public translate: TranslateService, public sanitizer: DomSanitizer) {
    // console.log('package : ', this.package);

  }

  ngOnInit() {
    const newThis = this;
    setInterval(() => {
      newThis.isheight();
    }, 500);
    this.lanList = this.package.lanList;
    console.log('package : ', this.lanList);
  }

  public isheight(): void {

    if (document.querySelectorAll<HTMLElement>('.popup-container').length) {


      const element = document.querySelectorAll<HTMLElement>('.popup-container')[0];
      const element2 = document.querySelectorAll<HTMLElement>('.popup-container-inner')[0];

      if ((element && element2) && element.offsetHeight < element2.offsetHeight) {
        this.isheighok = false;
      } else {
        this.isheighok = true;
      }

    }
  }

  public dismiss() {
    this.modalController.dismiss({
      'dismissed': true,
      'array': 'kk'
    });
  }

  addToCart(){
    this.modalController.dismiss({
      addToCart:true
    })
  }

  doNotShowAgain(){
    this.appService.appObject.doNotShowWelcomePackage = true;
    this.appService.updateAppObject();
    this.dismiss();
  }

}
